module.exports = __webpack_public_path__ + "media/customizations/westphalia/back-630a941834233ff96615bf41e2cb20dd.jpg";